import React from 'react';
import './EmojiPicker.css'
import Emojis from './EmojiMarkdown';
//import emoji from 'emoji-parser';

//const emoji = require('emoji-parser');
window.emojify.setConfig({ img_dir: "images/emojis" });
const $ = window.$;

export default class EmojiPicker extends React.Component {
    constructor(p) {
        super(p)
        this.state = {
            active: "People"
        }

        this.isActive = false
    }

    onEmojiSelect(emoji) {
        //console.log(emoji)
        this.props.onEmojiSelect(" "+emoji+" ")
    }

    render() {
        window.emojify.run(this.elem)
        return (
            <div className={"emoji-picker " + this.props.className} onFocus={() => this.isActive = true} onBlur={() => this.isActive = false} tabIndex={0} ref={(ref) => this.main = (ref === null) ? this.main : ref}>
                <i className="material-icons" onClick={() => {
                    if (!this.isActive) {
                        this.main.blur();
                    } else {
                        this.main.focus();
                    }
                }}>mood</i>
                <div className="emoji-picker-items" ref={(ref) => this.elem = (ref === null) ? this.elem : ref}>
                    <div className="emoji-icons-tabs">
                        {
                            Emojis.map((item, i) => {
                                return (
                                    <div key={i} className={(item.name === this.state.active) ? "emoji-icons-tab active" : "emoji-icons-tab"} dangerouslySetInnerHTML={{ __html: item.icon }} onClick={() => {
                                        this.setState({ active: item.name });
                                    }} />
                                )
                            })
                        }
                    </div>
                    <div className="emoji-icons-lists">
                        {
                            Emojis.map((item, i) => {
                                return (
                                    <div key={i} className={(item.name === this.state.active) ? "emoji-icons-list active" : "emoji-icons-list"} onClick={() => {
                                        this.setState({ active: item.name });
                                    }}>
                                        {
                                            item.data.map((icon, x) => {
                                                return (
                                                    <div key={x} className="emoji-icons-list-item" onClick={() => {
                                                        this.onEmojiSelect(icon)
                                                    }}>{icon}</div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EmojiPicker.js